define('app-blazy/main',['./settings', '../app-blazy/module'], function (settings, blazy) {
    return {
        run: function () {
            if ($(settings.container).length === 0) {
                window.log('No blazy container found.');
                return;
            }
            window.log('Loading bLazy');

            blazy.loadLazy();

            $('.owl-carousel').on('changed.owl.carousel', function () {
                blazy.loadLazy('container:".owl-carousel"');
            });

            window.loadedModules('bLazy');
        }
    }
});
